import moment from 'moment';

const APRIL = 2
const AUGUST = 7
const DECEMBER = 11
const DAY_OF_MONTH = 2

export function get_next_subscription_date(){
    let today = moment()
    let lastSubscriptionDate = moment().date(DAY_OF_MONTH).month(DECEMBER)
    const months = [APRIL, AUGUST, DECEMBER]
    const year = today.isAfter(lastSubscriptionDate) ? today.year() + 1 : today.year()
    const month = months.find(month => moment().date(DAY_OF_MONTH).month(month).year(year).isAfter(today))
    const nextSubscriptionDate = moment().date(DAY_OF_MONTH).month(month).year(year)

    return nextSubscriptionDate
}